export default __webpack_public_path__ + "static/media/topbar-icon-add-friend.dc717f98.svg";